import React, { Component } from 'react'
import {Row, Col, Label, Button} from "reactstrap";
import {observer} from "mobx-react";
import ModalForm from "../../../comum/components/ModalForm";
import ImportacaoNotasAdicionarStore from "../stores/ImportacaoNotasAdicionarStore";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import FormOnlyPositiveNumberSimples from "../../../comum/components/FormNumberSimples";
import { IconeDelete } from '../../../comum/components/Icones';
import {isInvalidoChaveNFe} from '../../../../utils/validadores';

@observer
export class ImportacaoNotasAdicionar extends Component {
    constructor(props) {
        super(props);

        this.controller = new ImportacaoNotasAdicionarStore(this.props.service);
        this.controllerDetalhes = this.props.controller;
        this.controllerImportacao = this.props.controllerImportacao;

        this.state = {salvado: false}
    };

    validar = () => {
        for (let x = 0; x < this.controller.listaChaves.length; x++) {
            let chave = this.controller.listaChaves[x];
            if (chave.chave.length!==44 || !chave.tipoServico || !chave.tipoNfe || (isInvalidoChaveNFe(chave.chave) !== false)) { return false; }
        }
        return true;
    };

    handleAdicionar = () => {
        this.setState({salvado: true});
        if (this.validar()) {
            this.controller.salvarChaves(this.controllerImportacao.linhaDetalhes.BlId, this.controllerImportacao.linhaDetalhes.ProtocoloId
                , () => this.controllerImportacao.atualizaNotas(this.controllerImportacao.linhaDetalhes.BlId, this.controllerImportacao.linhaDetalhes.NumeroBl, this.controllerImportacao.linhaDetalhes.ProtocoloId), () => this.handleFechar());
        }
    };

    handleFechar = () => {
        this.controllerDetalhes.modalAdicionarChaves = false;
    };

    render() {
        const naoSalvar = this.controller.listaChaves.length===0;
        let xs=12; let sm=4; let md=4; let lg=4; let xl=4;
        let xs2=12; let sm2=4; let md2=4; let lg2=4; let xl2=4;
        return (
            <ModalForm salvando={this.controller.aguardandoSalvar} className="area-form-modal"
                    onClickCancelar={ () => this.controllerDetalhes.modalAdicionarChaves = false }
                    labelConfirmar='SALVAR'
                    onClickSalvar={ this.handleAdicionar }
                    esconderSalvar={ naoSalvar } >
                <h2>Nova nota fiscal</h2>
                <div className={"importacao-detalhes-adiciona-notas"}>
                    <Row>
                        <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                            <Label>Chave acesso</Label>
                        </Col>
                        <Col xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}>
                            <Label>Tipo de retirada de carga</Label>
                        </Col>
                        <Col xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}>
                            <Label>Tipo de Nota Fiscal</Label>
                        </Col>
                    </Row>
                    { this.controller.listaChaves
                        && this.controller.listaChaves.map((c, x) =>
                        <div key={x} className={"control"} >
                            <Row>
                                <FormOnlyPositiveNumberSimples
                                xs={xs}
                                sm={sm}
                                md={md}
                                lg={lg}
                                xl={xl}
                                dado={c.chave}
                                limiteMaximo={44}
                                onChange={(event) => {
                                    let valor = event.target.value;

                                    // Remove tudo que não for número
                                    valor = valor.replace(/\D/g, '');

                                    // Chama o controller com o valor limpo
                                    this.controller.changeChave({ ...event, target: { ...event.target, value: valor } }, x);
                                }}
                                validador={isInvalidoChaveNFe}
                                alerta={this.state.salvado && c.chave.length !== 44 ? "Insira 44 caracteres" : false}
                            />
                                <FormSelectSimples xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}
                                    itens={ this.controllerImportacao.tiposRetiradaCarga }
                                    dado={ c.tipoServico }
                                    bloqueado={ !this.controllerImportacao.tiposRetiradaCarga }
                                    alerta={ this.state.salvado && !c.tipoServico ? "Campo obrigatório" : false }
                                    onChange={ (event) => this.controller.setTipo(event, x) } />
                                    <FormSelectSimples xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}
                                    itens={ this.controllerImportacao.tiposNfe }
                                    dado={ c.tipoNfe }
                                    bloqueado={ !this.controllerImportacao.tiposNfe }
                                    alerta={ this.state.salvado && !c.tipoNfe ? "Campo obrigatório" : false }
                                    onChange={ (event) => this.controller.setTipoNfe(event, x) } />
                                { this.controller.listaChaves.length > 1 &&
                                    <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={()=> this.controller.excluirNotasChaves(x)} />
                                }
                            </Row>
                            { this.controller.listaMsgs[x] ? <Label className="msg label-danger">{ this.controller.listaMsgs[x] }</Label> : "" }
                        </div>)
                    }
                    <Row>
                        <Button className="btn-primary" onClick={ this.controller.adicionarChave }>Adicionar</Button>                        
                    </Row>
                </div>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/components/ImportacaoNotasAdicionar.js